export default __webpack_public_path__ + "static/media/Diversey-Logo.501277a5.png";